module.exports = __webpack_public_path__ + "static/img/reason_head_5.19946bc5.png";